import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import CountUp from "../CountUp";
import Reveal from "../Reveal";

export default function StatsBand() {
  const { t } = useLanguage();
  const stats = [
    { value: 15,  suffix: "+",  k: "stats.years" },
    { value: 200, suffix: "+",  k: "stats.projects" },
    { value: 6,   suffix: "",   k: "stats.languages" },
    { value: 150, suffix: "%+", k: "stats.roi", prefix: "" },
  ];

  return (
    <section
      data-testid="stats-section"
      className="relative bg-noir text-cream py-section overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 bg-grain-dark opacity-50" />
      <div className="pointer-events-none absolute -top-24 start-1/2 -translate-x-1/2 h-[420px] w-[820px] rounded-full bg-gold/8 blur-3xl" />

      <div className="container-page relative">
        <Reveal as="div" className="max-w-2xl">
          <span className="eyebrow-on-dark">
            <span className="h-1 w-1 rounded-full bg-gold" />
            {t("stats.eyebrow")}
          </span>
          <h2 className="mt-5 font-display text-display-2 font-semibold text-cream">
            {t("stats.title_pre")}{" "}
            <span className="gold-foil-text">{t("stats.title_accent")}</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {stats.map((s, i) => (
            <Reveal as="div" key={s.k} delay={i * 0.1} className="border-t border-cream/12 pt-6">
              <div
                className="font-display font-semibold text-cream"
                style={{ fontSize: "clamp(3rem, 6vw, 5.5rem)", lineHeight: 1 }}
                data-testid={`stat-${s.k.split(".")[1]}`}
              >
                <CountUp to={s.value} suffix={s.suffix} prefix={s.prefix || ""} />
              </div>
              <p className="mt-3 text-sm text-cream/70 max-w-[16ch]">
                {t(`${s.k}.label`)}
              </p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
